import React, { useEffect, useState } from 'react'
import BreadcrumbComponent from '../../../CommonComponent/BreadcrumbComponent'
import { ResultBreadcrumb } from '../../../../../config/BreadcrumbConfig'
import { Button, Checkbox, CheckboxChangeEvent, Col, Dropdown, Flex, Form, Image, Modal, Progress, Radio, Row, Select, Space, Spin, Tooltip } from 'antd'
import { ArrowRightOutlined, CaretRightOutlined, DownloadOutlined, DownOutlined, LoadingOutlined, QuestionCircleOutlined } from '@ant-design/icons'
import CommonModal from '../../../../../components/Modals/CommonModal';
// import { ReactComponent as GraphImage } from "../../../../../assets/images/icon/Figpie.svg";
import { disabledWelcomeModal, downloadReportPdf, examResult, fetchInterestAssessment, fetchSkillAssessment, getExamList, setGoSkillModal, setskillSuccessPopup, startExam, updateUsersIndustry } from '../Utils/slice'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '../../../../../store/app'
import PageSpinner from '../../../../../components/PageSpinner/PageSpinner'
import { WebConstant } from '../../../webConstant/WebConstant';
import { b64toBlob, contentMarkupWithClass, formatGlobalPrice, get_users_industry, Notification, setResetInputAnimation, snakeCaseString, SvgToBase64 } from '../../../../../config/Global'
import { getStatus } from '../../../HomePage/utils/slice'
import CareerWheel from "./CareerWheel/CareerWheel";
import { Link, useNavigate } from 'react-router-dom'
import dayjs from 'dayjs'
import SVGIcon from '../../../../../utils/SVGIcon';
import DashboardNoDataBg from "../../../../../assets/images/dashboard-no-data.svg?react";
import SuccessIntrestIcon from "../../../../../assets/images/icon/success-intrest-icon.svg?react";
import StronglyAgree from "../../../../../assets/images/icon/examAnswerIcon/Agree.svg?react";
import Agree from "../../../../../assets/images/icon/examAnswerIcon/stronglyAgree.svg?react";
import Unsure from "../../../../../assets/images/icon/examAnswerIcon/Unsure.svg?react";
import StronglyDisagree from "../../../../../assets/images/icon/examAnswerIcon/StronglyDisagree.svg?react";
import Disagree from "../../../../../assets/images/icon/examAnswerIcon/Disagree.svg?react";

import { setUserOptions, thinkificCreatePassword } from '../../../../../store/AuthSlice'
import { setHasProfileUpdated, setShowIntrestPopup } from '../../../../../store/CommonSlice'
import StepperAnimation from './StepperAnimation/StepperAnimation'
import { FormBox, InputBox } from '../../../../../components/AntdAddons'

import { rules } from '../ProfileChangePassword/Rules'


const Result = () => {
    const [reportDetails, setReportDetails] = useState<any>(false)
    const dispatch: AppDispatch = useDispatch();
    const [resultData, setResultData] = useState<any>();
    const [loading, setLoading] = useState<boolean>(true);
    const [loadingPdf, setLoadingPdf] = useState<boolean>(false);
    const [loadingQuestionPdf, setLoadingQuestionPdf] = useState<boolean>(false);
    const [detailsModalId, setDetailsModalId] = useState<any>(null);
    const pageSettings = useSelector((state: RootState) => state.HOME?.pageSettings)


    const [selectedIndustry, setSelectedIndustry] = useState(null);
    const [selectedIndustryPopup, setSelectedIndustryPopup] = useState(selectedIndustry);
    const [openModal, setOpenModal] = useState<boolean>(false)
    const [videoModal, setVideoModal] = useState<boolean>(false)
    const modalVideo = pageSettings?.career_compass?.compass_video_youtube_url;
    const videoId = modalVideo?.split('v=')[1];

    const [allIndustryList, setAllIndustryList] = useState<any>([]);

    /* --------------------------------------------------------OLD-------------------------------------------------------- */

    const { profileProgress, userDetail } = useSelector((state: RootState) => state.AUTH)
    const { goSkillModal, skillSuccessPopup } = useSelector((state: RootState) => state.WEBPROFILE)
    const { showIntrestPopup, hasProfileUpdated } = useSelector((state: RootState) => state.COMMON)
    const translationLanguage = useSelector((state: RootState) => state.COMMON.translationLanguage);

    const navigate = useNavigate();
    const [interestOpenModal, setInterestOpenModal] = useState<boolean>(false);
    const [instructionInterest, setIntructionInterest] = useState<boolean>(false);
    const [examStartLoading, setExamStartLoading] = useState<boolean>(false);
    const [skillOpenModal, setSkillOpenModal] = useState<boolean>(false);
    const [skillInstructionModal, setSkillInstructionModal] = useState<boolean>(false);
    const [resultOpenModal, setResultOpenModal] = useState<boolean>(false);
    const [sureStartExam, setSureStartExam] = useState<boolean>(false);
    const [openWelcomeModal, setOpenWelcomeModal] = useState<boolean>(true);
    const [welcomeValue, setWelcomeValue] = useState<any>();
    const [feedBackModal, setFeedBackModal] = useState<any>("false")
    const [myindustryModal, setMyindustryModal] = useState<any>(false)
    const [createThinkificPasswordModal, setCreateThinkificPasswordModal] = useState<any>(false)
    const [options, setOption] = useState<any>();
    const svgIcons: any = {
        strongly_agree: <StronglyAgree />,
        agree: <Agree />,
        neutral: <Unsure />,
        disagree: <Disagree />,
        strongly_disagree: <StronglyDisagree />,
    };

    const initialData: any = sessionStorage.getItem("initialData");
    const welcomeData: any = sessionStorage.getItem("welcomeData") || null;
    const initialDataJson = JSON.parse(initialData);
    const initialStoreData: any = useSelector((state: RootState) => state.AUTH.initialData);

    const [form] = Form.useForm();
    const { is_solar } = get_users_industry(userDetail);
    console.log('is_solar,is_wind', is_solar)

    const surveyLink = userDetail && is_solar ? "https://www.surveymonkey.com/r/SolarECN" : "https://www.surveymonkey.com/r/energycareernavigator";

    /* --------------------------------------------------------OLD-------------------------------------------------------- */




    useEffect(() => {
        dispatch(getStatus("homepage")).catch((error: any) => error)
        window.scrollTo({ top: 0, behavior: "smooth" });
        localStorage.setItem("feedback", "true")
    }, [])


    useEffect(() => {

        if (userDetail != null) {
            // console.log('userDetail', userDetail)
            if (userDetail.result_status == 1) {
                dispatch(examResult()).then((data: any) => {
                    setResultData(data.data)
                    setLoading(false)
                }).catch((e: any) => {
                    e
                    setLoading(false)
                })
            }
            else {
                setLoading(false)
            }


            if (userDetail?.thinkific_flag == 1 && userDetail?.thinkific_password_change == 0) {
                setCreateThinkificPasswordModal(true);
            }
            else {
                setCreateThinkificPasswordModal(false);
            }

            // if (userDetail.popup_disabled !== 1) {
            //     dispatch(disabledWelcomeModal()).catch((e: any) => e)
            // }
            if (userDetail?.company_industries && userDetail?.industry_id) {
                setSelectedIndustry(userDetail.industry_id);
                setAllIndustryList(userDetail.company_industries.map(((industry: any) => {
                    return {
                        label: industry.industry_name,
                        value: industry.id,
                        is_available: industry.is_available,

                    }
                })))
                // console.log('userDetail', , userDetail?.industry?.industry_name)
            }
        }
    }, [userDetail])


    useEffect(() => {
        if (createThinkificPasswordModal) {
            form.resetFields();
            setTimeout(() => {
                setResetInputAnimation();
            }, 1000);

        }
        else {
            setResetInputAnimation(false);
        }
        return () => {
            setResetInputAnimation(false);
        };
    }, [createThinkificPasswordModal])





    // Downloads career compass report as a PDF file.
    const downloadReport = () => {

        let svg: any = document.querySelectorAll('.graphImage svg');
        if (svg.length > 0) {
            svg = svg[0];
            let base64image = SvgToBase64(svg);
            const requestData = {
                image: base64image
            }

            setLoadingPdf(true)
            dispatch(downloadReportPdf(requestData)).then((data: any) => {
                const file = b64toBlob(data.data, "application/pdf", 512);
                //Build a URL from the file
                const fileURL = URL.createObjectURL(file);
                //Open the URL on new Window
                const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

                if (isSafari) {

                    const link = document.createElement("a");
                    link.href = fileURL;
                    link.target = "_blank"; // This is ignored when 'download' is set

                    link.download = "Result.pdf"; // Set filename here
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(fileURL); // Clean up
                    window.open(fileURL, "_blank");

                } else {
                    window.open(fileURL, "_blank");
                }




                // const pdfWindow:any = window.open("");
                // pdfWindow.document.write(
                //     `<iframe width='100%' height='100%' src='data:application/pdf;base64,${data.data}'></iframe>`
                // );

                setLoadingPdf(false)
            }).catch((e: any) => {
                e
                setLoadingPdf(false)
            }
            )
        }


    }



    // const createAndstartInterestExam = () => {
    //     dispatch(fetchInterestAssessment()).then((data: any) => {
    //         const payload = {
    //             start_time: dayjs().format('YYYY-MM-DD HH:mm:ss'),
    //             assessment_type: "2",
    //             question_ids: data.data.ids
    //         }

    //         if (payload) {
    //             dispatch(startExam(payload))
    //                 .then((data: any) => {
    //                     const base64EncodedId = btoa(data?.data?.exam_id);
    //                     navigate(`/interest-assessment-exam-pending/${base64EncodedId}`)
    //                 }).catch((e: any) => e)
    //         }
    //     }).catch((e: any) => e)
    // }

    // Download career compass info pdf file.
    const handleFetchPdf = () => {
        setLoadingQuestionPdf(true);
        try {
            let url = translationLanguage == "es" && pageSettings?.career_compass?.cc_hint_document_spanish ? pageSettings?.career_compass?.cc_hint_document_spanish : pageSettings?.career_compass?.cc_hint_document;
            window.open(WebConstant?.IMAGE_URL + url, '_blank');
            setLoadingQuestionPdf(false);
            // window.open(WebConstant?.IMAGE_URL + pageSettings?.career_compass?.cc_hint_document, '_blank');
            setLoadingQuestionPdf(false);
        } catch (error) {
            setLoadingQuestionPdf(false);
            console.error('Error opening PDF:', error);
        }
    };

    // const interest = () => {
    //     if (Number(profileProgress) >= 90) {
    //         // setInterestOpenModal(true)
    //         alert('intrest');
    //     } else {
    //         navigate("/user-profile")
    //         Notification.error({
    //             placement: "top",
    //             message: "Complete your profile to begin your Career Discovery Journey."
    //         })

    //     }
    // }

    // const skill = () => {
    //     if (Number(profileProgress) >= 90) {
    //         // setSkillOpenModal(true)
    //         alert('skill');


    //     } else {
    //         navigate("/user-profile")
    //         Notification.error({
    //             placement: "top",
    //             message: "Complete your profile to begin your Career Discovery Journey."
    //         })

    //     }
    // }


    const changeUserIndustry = (industry_id: any) => {
        setLoading(true);
        const req = {
            industry_id: industry_id
        }
        dispatch(updateUsersIndustry(req))
            .then((data: any) => {
                setSelectedIndustry(industry_id)
                setMyindustryModal(false);
                setLoading(false);
            }).catch((e: any) => e)
    }


    /* --------------------------------------------------------OLD-------------------------------------------------------- */

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, [])

    useEffect(() => {

        dispatch(setUserOptions()).catch((e: any) => e)
        if (instructionInterest || interestOpenModal) {
            if (initialDataJson) {
                setOption(initialDataJson?.interest_assessment_options_type)
            } else {
                setOption(initialStoreData?.interest_assessment_options_type)
            }
        } else {
            if (initialDataJson) {
                setOption(initialDataJson?.start_exam_experience_levels)
            } else {
                setOption(initialStoreData?.start_exam_experience_levels)
            }
        }
        const feedBackModalData: any = localStorage.getItem("feedback")
        if (feedBackModalData) {
            setFeedBackModal(feedBackModalData)
        }
    }, [initialData, interestOpenModal, instructionInterest, skillOpenModal, skillInstructionModal, selectedIndustry])


    useEffect(() => {
        if (userDetail?.exam_flag == undefined || userDetail.exam_flag == 0) {
            setIntructionInterest(showIntrestPopup);
        }
    }, [showIntrestPopup])


    const [profileRetakeExamPopup, setProfileRetakeExamPopup] = useState(false);
    useEffect(() => {
        if (hasProfileUpdated) {
            if (userDetail?.result_status == 1) {
                setProfileRetakeExamPopup(true);
            }

            dispatch(setHasProfileUpdated(false));
        }
    }, [hasProfileUpdated])


    const closeFeedBackModal = () => {
        localStorage.removeItem("feedback")
        setFeedBackModal("false")
    }

    // Functions to close different modals : start
    const closeModal = () => {
        setInterestOpenModal(false)
        setSkillOpenModal(false)
        setResultOpenModal(false)
        setExamStartLoading(false)
        setProfileRetakeExamPopup(false);
        dispatch(setGoSkillModal(false))
        dispatch(setskillSuccessPopup(false))
    }

    const closeInstructionModal = () => {
        setExamStartLoading(false)
        dispatch(setShowIntrestPopup(false));
        if (interestOpenModal) {
            setIntructionInterest(false);
        }
        else {
            setSkillInstructionModal(false)
        }
    }

    const closeSureStartExam = () => {
        setSureStartExam(false)
        setExamStartLoading(false)
    }
    const closeWelcomeModal = () => {
        if (welcomeValue) {
            dispatch(disabledWelcomeModal()).catch((e: any) => e)
        }
        sessionStorage.setItem("welcomeData", 'yes');
        setOpenWelcomeModal(false)
    }
    // Functions to close different modals : end

    const sureExamModalContinue = () => {
        if (interestOpenModal) {
            setIntructionInterest(true)
        }
        else {
            setSkillInstructionModal(true)
        }
    }

    // Function to show Notification if profile is not complete else open exam modal: start
    const interest = () => {
        if (Number(profileProgress) >= 90) {
            setInterestOpenModal(true)
        } else {
            navigate("/user-profile")
            Notification.error({
                placement: "top",
                message: "Complete your profile to begin your Career Discovery Journey."
            })

        }
    }

    const skill = () => {
        if (Number(profileProgress) >= 90) {
            setSkillOpenModal(true)

        } else {
            navigate("/user-profile")
            Notification.error({
                placement: "top",
                message: "Complete your profile to begin your Career Discovery Journey."
            })

        }
    }
    // Function to show Notification if profile is not complete else open exam modal: End

    // To show result if both exam are completed.
    // const result = () => {
    //     if (userDetail?.result_status === 1) {
    //         navigate("/dashboard")

    //     } else {
    //         setResultOpenModal(true)
    //     }
    // }

    // const location = () => {
    //     navigate("/locations")
    // }

    // const acronyms = () => {
    //     navigate("/acronyms")
    // }
    // const resources = () => {
    //     navigate("/resources")
    // }

    // To navigate to exam page in case of  new exam
    const startExams = () => {
        dispatch(setShowIntrestPopup(false));
        setExamStartLoading(true)
        if (instructionInterest || interestOpenModal) {
            createAndstartInterestExam();
        } else {
            createAndstartSkillAssesment();
        }
    }


    const createAndstartInterestExam = () => {
        dispatch(fetchInterestAssessment()).then((data: any) => {
            const payload = {
                start_time: dayjs().format('YYYY-MM-DD HH:mm:ss'),
                assessment_type: "2",
                question_ids: data.data.ids
            }

            if (payload) {
                dispatch(startExam(payload))
                    .then((data: any) => {
                        const base64EncodedId = btoa(data?.data?.exam_id);
                        navigate(`/interest-assessment-exam-pending/${base64EncodedId}`)
                    }).catch((e: any) => e)
            }
        }).catch((e: any) => e)
    }

    const createAndstartSkillAssesment = () => {
        dispatch(fetchSkillAssessment()).then((data: any) => {
            const payload = {
                start_time: dayjs().format("YYYY-MM-DD HH:mm:ss"),
                assessment_type: "1",
                question_ids: data.data.ids,
            }
            if (payload) {
                dispatch(startExam(payload))
                    .then((data: any) => {
                        const base64EncodedId = btoa(data?.data?.exam_id);
                        navigate(`/skill-assessment-exam-pending/${base64EncodedId}`);
                    }).catch((e: any) => e)
            }
        }).catch((e: any) => e)
    }




    // To navigate to exam page in case of  pending exam
    const pendingExam = () => {
        if (interestOpenModal) {
            dispatch(getExamList("2")).then((data: any) => {
                const base64EncodedId = btoa(data?.data?.id);
                navigate(`/interest-assessment-exam-pending/${base64EncodedId}`)
            })
                .catch((e: any) => e)

        } else {
            dispatch(getExamList("1")).then((data: any) => {
                const base64EncodedId = btoa(data?.data?.id);
                navigate(`/skill-assessment-exam-pending/${base64EncodedId}`)
            })
                .catch((e: any) => e)
        }

    }

    // To navigate to exam page in case of completed exam
    const viewExam = () => {

        if (interestOpenModal) {
            dispatch(getExamList("2")).then((data: any) => {
                const base64EncodedId = btoa(data?.data?.id);
                navigate(`/interest-assessment-exam/${base64EncodedId}`)
            })
                .catch((e: any) => e)
        } else {
            dispatch(getExamList("1")).then((data: any) => {
                const base64EncodedId = btoa(data?.data?.id);
                navigate(`/skill-assessment-exam/${base64EncodedId}`)
            })
                .catch((e: any) => e)
        }


    }
    const goToSkillExam = () => {
        dispatch(setGoSkillModal(false))
        setSkillOpenModal(true)
    }


    const goToAllCareers = () => {
        navigate(`/careers`);
    }




    const ThinkificUserCreatePassword = (data: any) => {
        const req = {
            new_password: data.new_password,
        };

        dispatch(thinkificCreatePassword(req))
            .then(() => {
                dispatch(setUserOptions()).catch((e: any) => e)
                setCreateThinkificPasswordModal(false)
            })
            .catch((error: any) => console.log(form, error?.STATUS))

    }






    // !loading ? (
    return <section className='dashboard-sec'>
        <div className="container-fluid">
            <div className='breadcrumb has-button'>
                <BreadcrumbComponent
                    key={1}
                    items={ResultBreadcrumb.path}
                />
                <div className='breadcrum-right'>


                    {allIndustryList.length > 0 && <Dropdown
                        menu={{
                            items: allIndustryList.map((item: any) => ({
                                ...item,
                                label: item.label,
                                value: item.value,
                                key: item.value,
                                disabled: item.is_available != 1 || (userDetail && userDetail.trial_flag == 1),

                                onClick: () => changeUserIndustry(item.value),
                            })),
                        }}
                        trigger={["click"]}
                        placement="bottomRight"
                    >
                        <Space className="custom-sort-btn">
                            {allIndustryList.find((o: any) => o.value === selectedIndustry)?.label}
                            <DownOutlined />
                        </Space>
                    </Dropdown>}
                </div>

            </div>
            <div className="interesQnaSection reportSection career-compass">
                <div className='totalAns'>
                    <div className='ansListRadiobtn'>



                        <Row align={'stretch'} gutter={[15, 15]}>
                            <Col span={24} sm={24} md={12} xl={12}>
                                <a href='#' onClick={interest} className='career-tab-btn'>
                                    <span className='interest-tab-btn-icon'><SVGIcon icon="InterestDiscoveryIcon" /></span>
                                    <span className='interest-tab-btn-text'>1. Interest Discovery <SVGIcon icon="BreadcrumbArrowIcon" /></span>
                                </a>
                            </Col>

                            <Col span={24} sm={24} md={12} xl={12}>
                                <a href='#' onClick={skill} className={`career-tab-btn ${((userDetail?.interest_assessment_exam_status === 0 || userDetail?.interest_assessment_exam_status === 1) && userDetail?.last_skills_exam_id === 0) ? 'disable' : ''}`}>
                                    <span className='skill-tab-btn-icon'><SVGIcon icon="SkillPortraitIcon" /></span>
                                    <span className='skill-tab-btn-text'>2. Skill Portrait <SVGIcon icon="BreadcrumbArrowIcon" /></span>
                                </a>
                            </Col>
                            {resultData && userDetail?.profile_flag == 1 && userDetail?.result_status == 1 && <Col xs={24} sm={24} md={24} xl={24} >
                                <div className='reportContentBox profile-change-flow' >
                                    <h3>Update Detected – Retake Your Career Compass Results</h3>
                                    <p>You've updated your experience and/or education level. Based on these changes, your Career Compass results may no longer reflect your current profile.</p>
                                    <p>We recommend retaking the <Link className='career-link' to="#" onClick={() => createAndstartInterestExam()}>Interest Discovery</Link> and Skill Portrait to get the most accurate and relevant career matches for your updated qualifications.</p>
                                </div>
                            </Col>}
                            {userDetail && userDetail.result_status == 1 && resultData ?
                                <>
                                    <Col xs={24} sm={24} md={24} xl={8} style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                                        <div className="graf-download-box">
                                            <div className='career-compass-title'>

                                                <div className={`career-tab-btn  `}>
                                                    <span className='skill-tab-btn-icon career-compass-tab-btn-icon'><SVGIcon icon="CareerCompassIcon" /></span>
                                                    <span className='skill-tab-btn-text'>
                                                        3. Career Compass
                                                        {/* <SVGIcon icon="BreadcrumbArrowIcon" /> */}

                                                        {/* {userDetail.profile_flag == 1 && 'profile flag set'} */}
                                                    </span>
                                                </div>
                                                <div className='downloadAndInfo '>
                                                    {pageSettings?.career_compass?.cc_hint_document && <div className='reportInfo' onClick={handleFetchPdf} >
                                                        <Tooltip title="Need help understanding your Career Compass? Click Here!" trigger={'hover'} overlayClassName='examTooltip'>
                                                            {loadingQuestionPdf ? <Spin spinning={loadingQuestionPdf} indicator={<LoadingOutlined style={{ fontSize: 24 }} />} /> : <QuestionCircleOutlined />}

                                                        </Tooltip>
                                                    </div>}
                                                </div>
                                            </div>

                                            <CareerWheel resultData={resultData} />
                                            {(resultData?.exam_flag == undefined || resultData?.exam_flag == 0) && <div className='downloadAndInfo downloadAndInfoCenter'>
                                                <Spin style={{ color: '#169C16' }} spinning={loadingPdf} indicator={<LoadingOutlined style={{ fontSize: 24 }} />} />
                                                <div className='downloadReport' onClick={downloadReport}>
                                                    <DownloadOutlined /> <span className='downloadTitle'> Download Report</span>
                                                </div>
                                                <div className='downloadReportTooltip' onClick={downloadReport}>
                                                    <Tooltip title="Download your report" overlayClassName='examTooltip'>
                                                        {/* <Spin style={{ color: 'white' }} spinning={loadingPdf} indicator={<LoadingOutlined style={{ fontSize: 24 }} />} /> */}
                                                        {!loadingPdf && <DownloadOutlined />}
                                                    </Tooltip>
                                                </div>
                                                {/* {pageSettings?.career_compass?.cc_hint_document && <div className='reportInfo' onClick={handleFetchPdf} >
                                                    <Tooltip title="Need help understanding your Career Compass? Click Here!" trigger={'hover'} overlayClassName='examTooltip'>
                                                        {loadingQuestionPdf ? <Spin spinning={loadingQuestionPdf} indicator={<LoadingOutlined style={{ fontSize: 24 }} />} /> : <QuestionCircleOutlined />}

                                                    </Tooltip>
                                                </div>} */}
                                            </div>}
                                        </div>
                                    </Col>
                                    <Col sm={24} md={24} xl={16}>
                                        <div className="career-info-box">
                                            {resultData?.exam_flag != undefined &&
                                                <div className='reportContentBox default-result-flow' >
                                                    <p>Let&apos;s Keep Exploring,</p>
                                                    <p>Based on your responses, it looks like none of the current options stood out just yet, and that&apos;s okay. Career exploration is a process, and sometimes it takes a few steps to discover what feels right.</p>
                                                    <p>To help you get started, we&apos;re showing you a variety of careers you can begin exploring right now. You can also visit the <Link className='career-link' to="/careers" >Energy Careers Index</Link> page to see the full range of energy roles available. When you&apos;re ready, you can return to <Link className='career-link' to="#" onClick={() => createAndstartInterestExam()}>Interest Discovery</Link> at any time to continue your journey.</p>
                                                </div>
                                            }

                                            <Row gutter={[0, 15]}>
                                                {
                                                    resultData?.result?.map((item: any, index: number) =>
                                                        <Col sm={24} md={12} xl={12} key={index}>
                                                            <Link className='result-career' to={"/careers/details/" + item.careers_detail.id}>
                                                                <div className='reportContentBox' style={{ width: '100%' }} >
                                                                    <h3>{item.careers}</h3>

                                                                    <h6>{item.careers_detail.category_name}</h6>
                                                                    {
                                                                        item.careers_detail.description != null &&
                                                                            item.careers_detail.description.startsWith('<p') ?
                                                                            <div dangerouslySetInnerHTML={{ __html: item.careers_detail.description }}></div>
                                                                            :
                                                                            <div><p dangerouslySetInnerHTML={{ __html: item.careers_detail.description }}></p></div>
                                                                    }
                                                                    <div className='reportPrice' >{formatGlobalPrice(item.careers_detail.salary_start)} - {formatGlobalPrice(item.careers_detail.salary_end)}</div>

                                                                    <div className='interest-progess'>
                                                                        <div className='interest-progess-title'>Interest</div>
                                                                        <Tooltip title={`You scored ${Math.round(item?.interest_assessment_score)}% for Interest Discovery`} overlayClassName='examTooltip' trigger={'hover'}>
                                                                            <Progress percent={Math.round(item?.interest_assessment_score)} strokeColor="#DFFBDF" showInfo={true} percentPosition={{ align: 'center', type: 'outer' }} />
                                                                        </Tooltip>
                                                                    </div>

                                                                    <div className='skill-progess'>
                                                                        <div className='skill-progess-title'>Skill</div>
                                                                        <Tooltip title={`You scored ${Math.round(item?.skills_assessment_score)}% for Skill Portrait`} overlayClassName='examTooltip' trigger={'hover'}>
                                                                            <Progress percent={Math.round(item?.skills_assessment_score)} strokeColor="#E1F5FB" showInfo={true} percentPosition={{ align: 'center', type: 'outer' }} />
                                                                        </Tooltip>
                                                                    </div>
                                                                </div>
                                                            </Link>
                                                        </Col>
                                                    )
                                                }
                                            </Row>


                                            {(resultData?.exam_flag == undefined || resultData?.exam_flag == 0) && <div className='colorInformation' style={{ display: 'none' }}>
                                                <div className='colorInterest colorBox' >
                                                    <span className='interestColorBox '></span>
                                                    Interest Discovery

                                                </div>
                                                <div className='colorSkill colorBox'>
                                                    <span className='skillColorBox '></span>
                                                    Skill Portrait
                                                </div>
                                            </div>}

                                            {(modalVideo) && (
                                                <>

                                                    <div className="common-btn-arrow" onClick={() => setOpenModal(true)}>
                                                        <button className="arrow-btn" ><CaretRightOutlined />Watch Video</button>
                                                        <span className='cross-arrow'><ArrowRightOutlined /></span>
                                                    </div>
                                                    <div className="videoModal">
                                                        {openModal && <Modal
                                                            wrapClassName="videoModal"
                                                            open={openModal}
                                                            onCancel={() => closeModal()}
                                                            width={"800px"}
                                                            centered
                                                            footer={false}
                                                        >
                                                            <iframe
                                                                width="100%"
                                                                height="100%"
                                                                src={`https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&rel=0`}
                                                                title="YouTube Video"
                                                                // frameBorder="0"
                                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                                allowFullScreen
                                                            ></iframe>

                                                        </Modal>}
                                                    </div>
                                                </>

                                            )
                                            }

                                        </div>
                                    </Col>
                                </>
                                : <Col span={24}>
                                    <StepperAnimation userDetail={userDetail} />
                                </Col>
                            }
                        </Row>
                    </div>
                </div>
            </div>


            {/* <Col span={24}>
                <Flex vertical={true} justify={'center'} align={'center'} className='dashboard-no-data-flex' >
                    <div className='dashboard-no-data'>
                        <Flex vertical={true} justify={'center'} align={'center'} >

                            <DashboardNoDataBg />
                            {


                                userDetail?.last_interest_exam_id != 0 && (userDetail?.skill_assessment_exam_status === 0 || userDetail?.skill_assessment_exam_status === 1)
                                    ?
                                    <>
                                        <h3>You're almost there! </h3>
                                        <p> Next, complete the Skills Portrait to see how your abilities align with different career paths.</p>
                                    </>
                                    :
                                    <>
                                        <h3>Click on Interest Discovery</h3>
                                        <p> Explore careers that align with your interests and abilities by first completing the Interest Discovery profile, then the Skills Portrait journey above.</p>
                                    </>
                            }
                        </Flex>

                    </div>
                </Flex>
            </Col> */}

            {/*Modal for career Detail */}
            {/* <CareerDetailsModal career_id={detailsModalId} onCancel={() => setDetailsModalId(null)} /> */}

            {/* Interest section start */}
            <CommonModal
                title={
                    (userDetail?.interest_assessment_exam_status === 0 || userDetail?.exam_flag == 1) ? "Interest Discovery" :
                        userDetail?.interest_assessment_exam_status === 1 ? "Interest Discovery" :
                            "Retake Interest Discovery?"
                }
                open={interestOpenModal}
                onCancel={closeModal}
                className='startExamModal'
                footer={<Row gutter={[15, 15]}>
                    {
                        (userDetail?.interest_assessment_exam_status === 0 || userDetail?.exam_flag == 1)
                            ?
                            <Col xs={24} sm={24} md={24} lg={24}>
                                <Button
                                    key="2"
                                    htmlType="button"
                                    className='common_button green_border_common_btn common_fill_button'
                                    onClick={() => startExams()}
                                    loading={examStartLoading}

                                >
                                    Start
                                </Button>
                            </Col>
                            :
                            userDetail?.interest_assessment_exam_status === 1
                                ?
                                <>
                                    <Col xs={24} sm={12} md={12} lg={12}>
                                        <Button
                                            key="1"
                                            htmlType="button"
                                            className='common_button green_border_common_btn'
                                            onClick={() => pendingExam()}

                                        >
                                            Resume assessment
                                        </Button>
                                    </Col>
                                    <Col xs={24} sm={12} md={12} lg={12}>
                                        <Button
                                            key="2"
                                            htmlType="button"
                                            className='common_button green_border_common_btn common_fill_button'
                                            onClick={() => setSureStartExam(true)}
                                        >
                                            Begin new assessment
                                        </Button>
                                    </Col>
                                </>
                                :
                                <>
                                    <Col xs={24} sm={12} md={12} lg={12}>
                                        <Button
                                            key="2"
                                            htmlType="button"
                                            className='common_button green_border_common_btn '
                                            onClick={() => setIntructionInterest(true)}
                                            loading={examStartLoading}
                                        >
                                            Retake
                                        </Button>
                                    </Col>
                                    <Col xs={24} sm={12} md={12} lg={12}>
                                        <Button
                                            key="1"
                                            htmlType="button"
                                            className='common_button green_border_common_btn common_fill_button'
                                            onClick={() => viewExam()}
                                        >
                                            View Interest Discovery
                                        </Button>
                                    </Col>
                                </>
                    }

                </Row>}
            >
                {
                    (userDetail?.interest_assessment_exam_status === 0 || userDetail?.exam_flag == 1)
                        ?
                        <>
                            <h2 className='instructionTitle'>Here’s how Interest Discovery works. . .</h2>
                            <p>Interest Discovery asks you 50 quick questions about different work activities in the energy industry and beyond. For each one, you will decide how much you would enjoy doing that type of work.</p>
                            <p>Take your time. This is your opportunity to learn about your interests and uncover careers you may enjoy and find rewarding.</p>
                            <p>It takes about <strong>10 minutes to complete,</strong> and your progress will be saved automatically.</p>
                        </>
                        :
                        userDetail?.interest_assessment_exam_status === 1
                            ?
                            <>
                                <p>There is currently an assessment in progress. Would you like to continue your assessment or start over?</p>

                            </>
                            :
                            <>
                                <p>Retaking will replace your current responses and may change your Skill Portrait and Career Compass.</p>

                            </>
                }

            </CommonModal>
            <CommonModal
                title={interestOpenModal ? "Interest Discovery" : "Skill Discovery"}
                open={sureStartExam}
                onCancel={closeSureStartExam}
                className='startExamModal'

                footer={<Row gutter={[15, 15]}>
                    <Col xs={24} sm={24} md={24} lg={24}>
                        <Button
                            key="2"
                            htmlType="button"
                            className='common_button green_border_common_btn common_fill_button'
                            onClick={sureExamModalContinue}
                            loading={examStartLoading}

                        >
                            Continue
                        </Button>
                    </Col>
                </Row>}
            >
                <p>Your progress will be lost if you choose to start a new assessment. Please select continue to begin.</p>

            </CommonModal>



            <CommonModal
                title={"Update Detected"}
                open={profileRetakeExamPopup}
                onCancel={closeModal}
                className='startExamModal'
                footer={<Row gutter={[15, 15]}>
                    <Col xs={24} sm={12} md={12} lg={12}>
                        <Button
                            key="1"
                            htmlType="button"
                            className='common_button green_border_common_btn '
                            onClick={() => { createAndstartInterestExam() }}
                            loading={examStartLoading}
                        >
                            Yes
                        </Button>

                    </Col>
                    <Col xs={24} sm={12} md={12} lg={12}>
                        <Button
                            key="2"
                            htmlType="button"
                            className='common_button green_border_common_btn common_fill_button'
                            onClick={() => closeModal()}
                            loading={examStartLoading}
                        >
                            No
                        </Button>

                    </Col>
                </Row>}
            >
                <>
                    <h2 className='instructionTitle'>Refresh Your Career Compass Results</h2>
                    <p>You've updated your experience and/or education level. Based on these changes, your <b>Career Compass</b> results may no longer reflect your current profile.</p>
                    <p>We recommend retaking the <b>Interest Discovery</b> and <b>Skill Portrait</b> to get the most accurate and relevant career matches for your updated qualifications.</p>
                    <p><b>Would you like to retake the Career Discovery Journey now?</b></p>
                </>
            </CommonModal>


            <CommonModal
                title={"Interest Discovery"}
                open={instructionInterest}
                onCancel={closeInstructionModal}
                className='startExamModal'
                footer={<Row gutter={[15, 15]}>
                    <Col xs={24} sm={24} md={24} lg={24}>
                        <Button
                            key="2"
                            htmlType="button"
                            className='common_button green_border_common_btn common_fill_button'
                            onClick={() => startExams()}
                            loading={examStartLoading}

                        >
                            Start
                        </Button>
                    </Col>
                </Row>}
            >
                <>

                    <h2 className='instructionTitle'>Here’s how Interest Discovery works. . .</h2>
                    <p>Interest Discovery asks you 50 quick questions about different work activities in the energy industry and beyond. For each one, you will decide how much you would enjoy doing that type of work.</p>
                    <p>Take your time. This is your opportunity to learn about your interests and uncover careers you may enjoy and find rewarding.</p>
                    <p>It takes about <strong>10 minutes to complete,</strong> and your progress will be saved automatically.</p>

                </>
            </CommonModal>

            {/* Interest section end */}



            {/* skill section start */}
            <CommonModal
                title={
                    (userDetail?.interest_assessment_exam_status !== 2) ? "Skill Portrait" :
                        userDetail?.skill_assessment_exam_status === 0 ? "Skill Portrait" :
                            userDetail?.skill_assessment_exam_status === 1 ? "Skill Portrait" :
                                "Retake Skill Portrait?"
                }
                open={skillOpenModal}
                onCancel={closeModal}
                className='startExamModal'
                footer={
                    <Row gutter={[15, 15]}>

                        {(userDetail?.interest_assessment_exam_status !== 2)
                            ?
                            <>
                                {userDetail?.last_skills_exam_id !== 0 &&

                                    <Col xs={24} sm={24} md={24} lg={24} >
                                        <Button
                                            key="1"
                                            htmlType="button"
                                            className='common_button green_border_common_btn common_fill_button'
                                            onClick={() => viewExam()}
                                        >
                                            View exam
                                        </Button>
                                    </Col>
                                }
                            </>
                            :
                            userDetail?.skill_assessment_exam_status === 0
                                ?
                                <>

                                    <Col xs={24} sm={24} md={24} lg={24} >
                                        <Button
                                            key="2"
                                            htmlType="button"
                                            className='common_button green_border_common_btn common_fill_button'
                                            onClick={() => startExams()}
                                            loading={examStartLoading}

                                        >
                                            Start
                                        </Button>
                                    </Col>
                                </>
                                :
                                userDetail?.skill_assessment_exam_status === 1
                                    ?
                                    <>
                                        <Col xs={24} sm={12} md={12} lg={12}>
                                            <Button
                                                key="1"
                                                htmlType="button"
                                                className='common_button green_border_common_btn'
                                                onClick={() => pendingExam()}

                                            >
                                                Resume assessment
                                            </Button>
                                        </Col>
                                        <Col xs={24} sm={12} md={12} lg={12}>
                                            <Button
                                                key="2"
                                                htmlType="button"
                                                className='common_button green_border_common_btn common_fill_button'
                                                onClick={() => setSureStartExam(true)}
                                            >
                                                Begin new assessment
                                            </Button>
                                        </Col>
                                    </>
                                    :
                                    (userDetail?.skill_assessment_exam_status === 2 || userDetail?.skill_assessment_exam_status === 4) ?
                                        <>
                                            <Col xs={24} sm={24} md={24} lg={24}>
                                                <Button
                                                    key="1"
                                                    htmlType="button"
                                                    className='common_button green_border_common_btn common_fill_button'
                                                    onClick={() => viewExam()}
                                                >
                                                    View exam
                                                </Button>
                                            </Col>
                                        </>
                                        :
                                        <>
                                            <Col xs={24} sm={12} md={12} lg={12}>
                                                <Button
                                                    key="2"
                                                    htmlType="button"
                                                    className='common_button green_border_common_btn '
                                                    onClick={() => setSkillInstructionModal(true)}
                                                >
                                                    Retake
                                                </Button>
                                            </Col>
                                            <Col xs={24} sm={12} md={12} lg={12}>

                                                <Button
                                                    key="1"
                                                    htmlType="button"
                                                    className='common_button green_border_common_btn common_fill_button'
                                                    onClick={() => viewExam()}
                                                >
                                                    View Skill Portrait
                                                </Button>
                                            </Col>
                                        </>}
                    </Row>
                }>
                {

                    (userDetail?.interest_assessment_exam_status !== 2)
                        ?
                        <>
                            <p>Please complete your Interest Discovery prior to taking the Skill Portrait.</p>
                        </>
                        :
                        userDetail?.skill_assessment_exam_status === 0
                            ?
                            <>
                                <h2 className='instructionTitle'>Here’s how Skill Portrait works...</h2>
                                <p>In this step of your Career Discovery Journey, you will answer about 20 questions about skills and abilities valued across energy careers. For each one, choose the response that best reflects your current skills or experience. </p>
                                <p>Your responses will help create a clear picture of your strengths and how they connect to potential career paths in the energy industry. </p>
                                <p>It takes about <strong>10 minutes to complete,</strong> and your progress will be saved automatically. </p>
                            </>
                            :
                            userDetail?.skill_assessment_exam_status === 1
                                ?
                                <>
                                    <p>There is currently an assessment in progress. Would you like to continue your assessment or start over?</p>
                                </>
                                :
                                (userDetail?.skill_assessment_exam_status === 2 || userDetail?.skill_assessment_exam_status === 4) ?
                                    <>
                                        <p>Please complete your Interest Discovery prior to taking the Skill Portrait.</p>
                                    </>
                                    :
                                    <>
                                        <p>Retaking will replace your current results and may change your Career Compass.</p>
                                    </>
                }
            </CommonModal >

            <CommonModal
                title={"Skill Portrait"}
                open={skillInstructionModal}
                onCancel={closeInstructionModal}
                className='startExamModal'
                footer={<Row>
                    <Col xs={24} sm={24} md={24} lg={24}>
                        <Button
                            key="2"
                            htmlType="button"
                            className='common_button green_border_common_btn common_fill_button'
                            onClick={() => startExams()}
                            loading={examStartLoading}

                        >
                            Start
                        </Button>
                    </Col></Row>}
            >
                <>
                    <h2 className='instructionTitle'>Here’s how Skill Portrait works...</h2>
                    <p>In this step of your Career Discovery Journey, you will answer about 20 questions about skills and abilities valued across energy careers. For each one, choose the response that best reflects your current skills or experience. </p>
                    <p>Your responses will help create a clear picture of your strengths and how they connect to potential career paths in the energy industry. </p>
                    <p>It takes about <strong>10 minutes to complete,</strong> and your progress will be saved automatically. </p>
                </>
            </CommonModal>
            {/* skill section end */}


            {/* result section start */}
            <CommonModal
                title={"Career Compass"}
                open={resultOpenModal}
                onCancel={closeModal}
                className='startExamModal'
            >
                <p>Please complete your Interest Discovery and Skill Portrait to receive your Career Compass.</p>
            </CommonModal>
            {/* result section end */}



            {/* welcomeModal  */}
            {
                userDetail?.popup_disabled === 0 && welcomeData != 'yes' &&
                <CommonModal
                    title={"Welcome"}
                    open={openWelcomeModal}
                    onCancel={() => closeWelcomeModal()}
                    className='startExamModal'
                    centered
                    width={600}
                    footer={
                        <div>
                            <Checkbox
                                onChange={(e: CheckboxChangeEvent) => {
                                    setWelcomeValue(e.target.checked)
                                }}
                            >
                                {"Please do not show this again."}
                            </Checkbox>
                        </div>
                    }
                >
                    <p>Begin your <strong>Career Discovery Journey </strong> with <strong>Interest Discovery,</strong> continue with <strong>Skill Portrait,</strong> and unlock your <strong>Career Compass,</strong> your personalized guide to exploring energy careers. </p>
                    <p>Align your interests and skills with opportunities across the energy industry.</p>

                </CommonModal>
            }

            {/* this modal open after complete interest exam. use for going to Skill Portrait --- start */}

            <CommonModal
                title={"Interest Discovery "}
                open={goSkillModal}
                onCancel={() => closeModal()}
                className='startExamModal'
                footer={<Row gutter={[15, 15]}>
                    <Col span={24}>
                        <Button
                            key="2"
                            htmlType="button"
                            className='common_button green_border_common_btn common_fill_button'
                            onClick={() => goToSkillExam()}

                        >
                            Continue
                        </Button>
                    </Col>
                </Row>}
            >
                <>
                    <Flex justify='center' style={{ margin: '5% 0' }}>
                        <SuccessIntrestIcon />

                    </Flex>
                    <p><strong>Great work!</strong> You have completed Interest Discovery.</p>
                    <p>Continue with Skill Portrait to move closer to unlocking your Career Compass.</p>
                </>
            </CommonModal>

            {/* this modal open after complete interest exam. use for going to Skill Portrait --- end */}



            {/* this modal open after complete skill exam. use for going to career discovery  --- start */}

            <CommonModal
                title={"Skill Portrait Complete"}
                open={skillSuccessPopup}
                onCancel={() => closeModal()}
                className='startExamModal'
                footer={<Row gutter={[15, 15]}>
                    <Col span={24}>
                        <Button
                            key="2"
                            htmlType="button"
                            className='common_button green_border_common_btn common_fill_button'
                            onClick={() => closeModal()}

                        >
                            Close
                        </Button>
                    </Col>
                </Row>}
            >
                <>
                    <Flex justify='center' style={{ margin: '5% 0' }}>
                        <SuccessIntrestIcon />
                    </Flex>
                    <p>You’ve unlocked your Career Compass, showing how your skills and interests connect to energy careers.</p>
                    <p>This is just the beginning of your <strong>Career Discovery Journey</strong> and now it’s time to explore your matches and discover where they can take you.</p>
                </>
            </CommonModal>

            {/* this modal open after complete skill exam. use for going to career discovery  --- end */}

            {/*start ---- this modal for when user out from result pages */}
            {/* <CommonModal
                title={"Feedback"}
                open={feedBackModal === "true"}
                onCancel={() => closeFeedBackModal()}
                width={650}
                footer={<Row gutter={[15, 15]}>
                    <Col span={24}>
                        <Button
                            key="2"
                            htmlType="button"
                            className='common_button green_border_common_btn'
                            onClick={() => closeFeedBackModal()}
                        >
                            Close
                        </Button>
                    </Col>
                </Row>}
                className='startExamModal feedBack'
            >

                <div className='feedBack'>
                    <p>Have any feedback about this experience? Share it with us: </p>
                    <div className='link'>
                        <a href={surveyLink} rel="noreferrer" target="_blank" >{surveyLink}</a>
                    </div>
                </div>
                {/* <div className='examStartModal'>

                </div> 
            </CommonModal> */}
            {/*end ---- this modal for when user out from result pages */}


            <CommonModal
                title={<>Choose Your Energy Sector<p>Select the industry you’d like to explore.</p></>}
                open={myindustryModal}
                onCancel={() => setMyindustryModal(false)}
                width={650}
                footer={<Row gutter={[15, 15]}>
                    <Col span={24}>
                        <Button
                            key="2"
                            htmlType="button"
                            className='common_button green_border_common_btn common_fill_button'
                            onClick={() => selectedIndustryPopup != null && changeUserIndustry(selectedIndustryPopup)}
                        >
                            Start
                        </Button>
                    </Col>
                </Row>}
                className='startExamModal feedBack'
            >

                <div className='user-industry-selection-section'>
                    <Radio.Group
                        defaultValue={selectedIndustryPopup || null}
                        size="large"
                        buttonStyle="solid"
                        onChange={(e) => e.target.checked && setSelectedIndustryPopup(e.target.value)}
                    >
                        <Row gutter={[15, 15]}>
                            {allIndustryList.length > 0 &&
                                allIndustryList.map((industry: any, index: any) =>
                                    <Col span={12} key={index} >
                                        <Radio.Button value={industry.value} >{industry.label}</Radio.Button>
                                    </Col>
                                )}
                        </Row>
                    </Radio.Group>
                </div>
            </CommonModal>


            <CommonModal
                title={<>Create Password</>}
                open={createThinkificPasswordModal}
                closable={false}
                // onCancel={() => setMyindustryModal(false)}
                width={650}
                footer={<Row gutter={[15, 15]}>
                    <Col span={24}>
                        <Button
                            form="changeThinkificPassword"
                            htmlType="submit"
                            className='common_button green_border_common_btn common_fill_button'
                        // onClick={() => selectedIndustryPopup != null && changeUserIndustry(selectedIndustryPopup)}
                        >
                            Submit
                        </Button>
                    </Col>
                </Row>}
                className='startExamModal feedBack'
            >

                <FormBox
                    layout="vertical"
                    autoComplete="off"
                    form={form}
                    id="changeThinkificPassword"
                    onFinish={ThinkificUserCreatePassword}
                    className=" commanDrawer"
                >
                    <Row gutter={[0, 24]}>
                        <Col sm={24} xs={24} md={24} xl={24} xxl={24}>
                            <InputBox.Password
                                name="new_password"
                                label={<>Enter new password <em>*</em></>}
                                placeholder=''
                                className="ecn-input profile-input"
                                // placeholder="New Password"
                                rules={rules.password()}
                            />
                        </Col>
                        <Col sm={24} xs={24} md={24} xl={24} xxl={24}>
                            <InputBox.Password
                                name="confirm_password"
                                label={<>Confirm new password <em>*</em></>}
                                placeholder=''
                                dependencies={['new_password']} // This ensures re-validation when 'password' changes
                                className="ecn-input profile-input"
                                rules={rules.password_confirmation()}
                            />
                        </Col>


                    </Row>

                </FormBox>
            </CommonModal>












        </div>
    </section >

    // ) : <PageSpinner />
}

export default Result
